export default __webpack_public_path__ + "static/standing-prince-ac63510349834d1abdcf6f65815c26ff.svg";